import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'
import { cn } from '@/lib/cn'

interface BedCounterProps {
  serviceLabel: string
  available: number
  occupied: number
  reserved: number
  total: number
  onUpdate: (field: 'available' | 'occupied' | 'reserved', value: number) => void
}

function CounterButton({ value, onChange, label, color }: { value: number; onChange: (v: number) => void; label: string; color: string }) {
  return (
    <div className="flex flex-col items-center gap-1">
      <span className={cn('text-xs font-medium', color)}>{label}</span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onChange(Math.max(0, value - 1))}
          className="w-7 h-7 rounded-md border border-neutral-200 flex items-center justify-center text-neutral-500 hover:bg-neutral-50 transition-colors"
        >
          <MinusIcon className="w-3.5 h-3.5" />
        </button>
        <span className={cn('w-8 text-center text-lg font-semibold tabular-nums', color)}>{value}</span>
        <button
          type="button"
          onClick={() => onChange(value + 1)}
          className="w-7 h-7 rounded-md border border-neutral-200 flex items-center justify-center text-neutral-500 hover:bg-neutral-50 transition-colors"
        >
          <PlusIcon className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  )
}

export function BedCounter({ serviceLabel, available, occupied, reserved, total, onUpdate }: BedCounterProps) {
  const pct = total > 0 ? Math.round((occupied / total) * 100) : 0

  return (
    <div className="flex items-center justify-between py-3 px-4 border-b border-neutral-100 last:border-b-0">
      <div className="min-w-[120px]">
        <p className="text-sm font-medium text-neutral-900">{serviceLabel}</p>
        <p className="text-xs text-neutral-400">{total} lits &middot; {pct}% occupé</p>
      </div>
      <div className="flex items-center gap-4 sm:gap-6">
        <CounterButton value={available} onChange={(v) => onUpdate('available', v)} label="Dispo" color="text-success-600" />
        <CounterButton value={occupied} onChange={(v) => onUpdate('occupied', v)} label="Occupé" color="text-error-600" />
        <CounterButton value={reserved} onChange={(v) => onUpdate('reserved', v)} label="Réservé" color="text-warning-600" />
      </div>
    </div>
  )
}
